module.exports = __webpack_public_path__ + "static/img/goat.88e92d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/goat.png
// module id = rbAT
// module chunks = 0